import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { GetStateResponse } from "../../Location";
import { Image } from "./GetInvoice.query";

export class GetInstanceResponse {
    id: number;
    name: string;
    username: string;
    description: string;
    country_id?: number;
    state_id?: number;
    city_id?: number;
    state?: GetStateResponse = new GetStateResponse();
    city?: any;
    address: string;
    mobile: string;
    phone: string;
    email: string;
    logo: Image;
    logo_id: string;
    category: string;
    private: boolean;
    domain: string;
}

export function getInstance(instance_id: number):  Promise<AxiosResponse<GetInstanceResponse>>{
    return Cirus.get(`/instance/${instance_id}`);
}